const type = 'SET_DISPUTE_TREE_SERVICE_PROBLEMS';

const setDisputeTreeServiceProblems = (data = []) => ({
  data,
  type,
});

export { type };
export default setDisputeTreeServiceProblems;
